import { Toast } from '@common/application/utils/ui/toast';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { LoginTabs } from '@/components/common/login-tabs';
import { LoginByPwd } from '@/components/page/login/login-by-pwd';
import { Register } from '@/components/page/register';

interface Props {
  onSuccess?: () => void;
  onNavigate?: () => void;
}

export const LoginAndRegisterModal = ({ onSuccess, onNavigate }: Props) => {
  const { t } = useTranslation('common');
  const [active, setActive] = useState<'login' | 'register'>('login');
  const handleRegisterSuccess = () => {
    Toast(t('register.registerSuccess'), {
      type: 'success'
    });
    setActive('login');
  };
  return (
    <LoginTabs
      className="pb-6"
      type={active}
      onTabChange={(type) => {
        setActive(type);
      }}
    >
      {active === 'login' && <LoginByPwd onSuccess={onSuccess} onNavigate={onNavigate} />}
      {active === 'register' && <Register onSuccess={handleRegisterSuccess} />}
    </LoginTabs>
  );
};
